import store from '@/store'
import router from '@/router';
export default {
    name: 'login',
    data() {
        return {
            loginForm: {
                username: '',
                password: '',
                Privacyradio: false,
            },
            rules: {
                username: [{ required: true, trigger: 'blur', message: "请输入账号" }],
                password: [{ required: true, trigger: 'blur', message: "请输入密码" }],

            },
            loading: false,
            dialoglogin: false,
        }
    },
    computed:{
        logoImg(){
            return store.state.user.company.companyLogo
        }
    },
    methods: {
        handleLogin() {
            this.$refs.loginRules.validate(valid => {
                if (valid) {
                    if (this.loginForm.Privacyradio == false) {
                        this.$message({
                            message: "请先阅读并同意隐私政策协议",
                            type: "error"
                        })
                        return
                    }
                    this.loading = true
                    store.dispatch('user/login', this.loginForm).then(() => {
                        // 登录成功
                        this.$message({
                            message: "登录成功 ！",
                            type: "success",
                            offset: "120"
                        });
                        store.dispatch('user/getInfo').then(() => {
                            console.log(this.data)
                            this.logincanshu()
                            this.$message({
                                message: "获取信息成功 ！",
                                type: "success",
                                offset: "120"
                            });
                            this.handleClose()
                            this.loading = false;
                            this.loginSuccess && this.loginSuccess()
                        }).catch(() => {
                            this.loading = false;
                        })
                    }).catch(() => {
                        this.loading = false;
                    })
                } else {
                    return false;
                }
            })
        },
        //清空数据
        logincanshu() {
            this.loginForm = {
                username: '',
                password: ''
            };
        },
        handleClose() {
            this.dialoglogin = false;
        },
        open() {
            this.dialoglogin = true
        },
        // 隐私政策
        changepriva(e) {
            this.loginForm.Privacyradio = e;
        },
        privacypaths() {
            let rourl = router.resolve({ path: "/privacys" });
            window.open(rourl.href);

        },

    }
}